import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmationScreen } from '../../components/ConfirmationScreen';
export function ConfirmationPage() {
  const navigate = useNavigate();
  const handleReset = () => {
    navigate('/guest');
  };
  return <ConfirmationScreen onReset={handleReset} data-id="element-910" />;
}